import { T } from 'consts/translationKeys'

interface ITranslateOptions {
  isUpper?: boolean
}

const translations = window.TRANSLATIONS || {}

export const translate = (key: T, options: ITranslateOptions = {}) => {
  const translatedLabel = translations[key]

  if (translatedLabel && options.isUpper) {
    return translatedLabel.toUpperCase()
  }

  return translatedLabel ?? key
}
